<template>
    <div class="cs-button-container">
        <button
          class="cs-button" :class="additionalClasses"
          v-on:click="initTrialRequest"
          @click="$emit('buttonClicked')"
        >{{text}}</button>
      </div>
</template>

<script>
export default {
    name: 'CsButton',
    emits: ['buttonClicked'],
    props: {
        additionalClasses: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>

.cs-button-container {
  padding: 0 20px;
}

.cs-button {
  font-family: "Poppins", sans-serif;
  color: #fff;
  width: 100%;
  min-height: 35px;
  height: fit-content;
  max-width: 100%;
  border-radius: 25px;
  border: none;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  font-weight: 600;
  margin: 15px 0;
  padding: 0 20px;
}

.cs-button__green {
  background-color: #61ce70;
}

.cs-button__orange {
  background-color: #F59B35;
}

.cs-button__purple {
  background-color: #7762EF;
}

@media (min-width: 768px) {
  .cs-button {
    font-size: 16px;
  }
}


</style>